import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#222",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12.332 5H4.999a3.667 3.667 0 0 0-3.667 3.666V27a3.667 3.667 0 0 0 3.667 3.666h18.333A3.667 3.667 0 0 0 26.999 27v-7.334M19.665 1.333h11m0 0v11m0-11L12.332 19.666"
    }, null, -1)
  ]))]))
}
export default { render: render }